import * as React from 'react';
import { useSelector } from 'react-redux';

import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

import { selectIsDataPayment } from '../../../selectors/dataPayment';
import { useHandleDatapaymentSubmit } from './useHandleDatapaymentSubmit';
import { useHandleJKSubmit } from './useHandleJKSubmit';
import { useHandleValuationSubmit } from './useHandleValuationSubmit';
import { useHandleSuburbanValuationSubmit } from './useHandleSuburbanValuationSubmit';
import { IApplicationState } from '../../../types/redux';

/** Обработчик клика по основной кнопке под строкой фильтров */
export const useHandleSubmit = () => {
  const { estimationTarget } = useSelector((state: IApplicationState) => state.filters);
  const isDataPayment = useSelector(selectIsDataPayment);
  const isSuburbanTarget = [EEstimationTargets.land, EEstimationTargets.house].includes(estimationTarget);

  // сабмит для поискуна
  const handleDatapaymentSubmit = useHandleDatapaymentSubmit();
  // сабмит для любого пользователя в оценке загородки
  const handleSuburbanDatapaymentSubmit = useHandleSuburbanValuationSubmit();
  // сабмит для оценки ЖК
  const handleJKSubmit = useHandleJKSubmit();
  // сабмин для агента
  const handleValuationSubmit = useHandleValuationSubmit();

  return React.useCallback<() => Promise<void>>(async () => {
    if (isSuburbanTarget) {
      /** Сюда попадают все пользователи (поискун/агент) при оценке загородки */
      handleSuburbanDatapaymentSubmit();

      return;
    }

    if (isDataPayment) {
      /** Сюда попадает только поискун - это расплата за оценку */
      handleDatapaymentSubmit();

      return;
    }

    if (estimationTarget === EEstimationTargets.newbuilding) {
      /** Сюда попадает любой юзер, оценивающий ЖК */
      handleJKSubmit();

      return;
    }

    handleValuationSubmit();
  }, [
    isSuburbanTarget,
    isDataPayment,
    estimationTarget,
    handleValuationSubmit,
    handleSuburbanDatapaymentSubmit,
    handleDatapaymentSubmit,
    handleJKSubmit,
  ]);
};
